export default function createLocomotive() {
  return this.$store.dispatch('locomotive/createLocomotive', {
    sideNumber: this.model.sideNumber,
    company: this.model.company['@id'],
  });
}
